import React from 'react'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Contractor from '../pages/Contractor';
import AddUpdateContractor from '../pages/Contractor/AddUpdateContractor';
import ContractorProfile from '../pages/Contractor/Profile';
import Employee from '../pages/Employee';
import EmployeeProfile from '../pages/Employee/Profile';
import Setting from '../pages/Setting';
import AddUpdateEmployee from '../pages/Employee/AddUpdateEmployee';
import Tenant from '../pages/Tenants';
import AddUpdateTenant from '../pages/Tenants/AddUpdateTenants';
import Task from '../pages/Tasks/contractor';
import AddUpdateTask from '../pages/Tasks/contractor/AddUpdateTask';
import MyTask from '../pages/Tasks//employee/MyTasks';
import UpdateMyTask from '../pages/Tasks//employee/UpdateMyTask';
import TaskHistory from '../pages/Tasks/employee/TaskHistory';
import EmployeeTasks from '../pages/Tasks/contractor/EmployeeTasks';
import RouteInfo from '../pages/RouteInfo';
import AddUpdateRouteInfo from '../pages/RouteInfo/AddUpdateRouteInfo';
import StartTask from '../pages/Tasks/employee/StartTask';
import NotFound from "../pages/NotFound";
import Reports from '../pages/Reports';
import Invoice from '../pages/Invoice/Invoice';
import CompanyProfile from '../pages/Tenants/Profile';
import GenerateInvoice from '../pages/Invoice/GenerateInvoice';
import PaySlip from '../pages/PaySlip';
import GenerateSlip from '../pages/PaySlip/GenerateSlip';
import AddUpdateEmployeeTask from '../pages/Tasks/contractor/AddUpdateEmployeeTask';
import Holidays from '../pages/Others/Holidays';
import RulesRegulation from '../pages/Others/RulesRegulation';
import Scanner from '../pages/Scanner'
import AddressGrid from '../pages/Scanner/AddressGrid';
import ParcelSorting from '../pages/ParcelSorting';
import PanelAddress from '../pages/RouteInfo/PanelAddress';
import PrintParcelAddress from '../pages/ParcelSorting/PrintParcelAddress';
import EmployeePanelAddress from '../pages/ParcelSorting/EmployeePanelAddress';
import OnboardingScreen from '../pages/Onboarding';
import ContactUs from '../pages/Onboarding/ContactUs';
import AboutUs from '../pages/Onboarding/AboutUs';
import Enquiry from '../pages/Admin/Enquiry';
import AddRouteAddress from '../pages/ParcelSorting/AddRouteAddress';
import GenerateParcelAddress from '../pages/ParcelSorting/GenerateParcelAddress';
import Street from '../pages/ParcelSorting/Street';

const Routers = () => {
  return (
     <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* <Route index path="/" element={<OnboardingScreen/>} /> */}
            <Route index path="/" element={<Login/>} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/contractors" element={<Contractor />} />
            <Route path="/contractor/profile" element={<ContractorProfile />} />
            <Route path="/contractor/companyprofile" element={<CompanyProfile />} />
            <Route path="/contractors/*" element={<AddUpdateContractor />} />
            <Route path="/employees" element={<Employee />} />
            <Route path="/employee/profile" element={<EmployeeProfile />} />
            <Route path="/employees/*" element={<AddUpdateEmployee />} />
            <Route path="/tasks" element={<Task />} />
            <Route path="/tasks/*" element={<AddUpdateTask />} />
            <Route path="/employeetasks" element={<EmployeeTasks />} />
            <Route path="/mytask" element={<MyTask/>} />
            <Route path="/mytask/start" element={<StartTask/>} />
             <Route path="/mytask/*" element={<UpdateMyTask/>} />
             <Route path="/taskhistory" element={<TaskHistory/>} />
            <Route path="/routeInfo" element={<RouteInfo />} />
            <Route path="/routeInfo/paneladdress" element={<PanelAddress/>} />
            <Route path="/routeInfo/*" element={<AddUpdateRouteInfo />}/>
            <Route path="/tenants" element={<Tenant />} />
            <Route path="/tenants/*" element={<AddUpdateTenant />} />
            <Route path="/settings" element={<Setting />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/generateinvoice" element={<GenerateInvoice />} />
            <Route path="/payslip" element={<PaySlip />} />
            <Route path="/generateslip" element={<GenerateSlip />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/employeetask/*" element={<AddUpdateEmployeeTask />} />
            <Route path="/holidays" element={<Holidays/>}/>
            <Route path="/rulesregulations" element={<RulesRegulation/>} />
            
            {/* <Route path="/scanner" element={<Scanner/>} /> */}
            <Route path="/parcelsorting" element={<ParcelSorting/>} />
            <Route path="/generateParcelAddress/paneladdress" element={<EmployeePanelAddress/>} />
            <Route path="/generateParcelAddress/addrouteAddress" element={<AddRouteAddress/>} />
             <Route path="/generateParcelAddress" element={<GenerateParcelAddress/>} />
            <Route path="/printAddress" element={<PrintParcelAddress/>} />
            <Route path="/grid" element={<AddressGrid/>} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/street" element={<Street/>} />
          </Routes>
        </div>
    </Router>
  )
}

export default Routers